const DEFAULT_LANGUAGE = 'en-US'

const types = {
  SET_LANGUAGE: 'SET_LANGUAGE',
  DELETE_LANGUAGE: 'DELETE_LANGUAGE',
}
const getStoredLanguage = () => {
  try {
    const stored = localStorage.getItem('language')
    return stored || DEFAULT_LANGUAGE
  } catch (error) {
    // In incognito mode localStorage May not be available, return default language
    console.warn('localStorage is not available, using default language')
    return DEFAULT_LANGUAGE
  }
}

const state = {
  languageStorage: getStoredLanguage(),
}
const getters = {
  languageStorage(state) {
    return state.languageStorage
  },
}

const actions = {
  setLanguage({ commit }, data) {
    commit(types.SET_LANGUAGE, data)
  },
  deleteLanguage({ commit }) {
    commit(types.DELETE_LANGUAGE)
  }
}

const mutations = {
  [types.SET_LANGUAGE](state, data) {
    try {
      localStorage.setItem('language', data)
    } catch (error) {
      console.warn('localStorage is not available, language preference will not be persisted')
    }
    state.languageStorage = data
  },
  [types.DELETE_LANGUAGE](state, data) {
    try {
      localStorage.removeItem('language')
    } catch (error) {
      console.warn('localStorage is not available')
    }
    state.languageStorage = DEFAULT_LANGUAGE
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}